import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, indexedDBLocalPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import Constants from "expo-constants";

const apiKey =
  // Expo recommends using EXPO_PUBLIC_* for web bundling
  process.env.EXPO_PUBLIC_API_KEY ||
  Constants.expoConfig?.extra?.EXPO_PUBLIC_API_KEY ||
  Constants.expoConfig?.extra?.API_KEY;

if (!apiKey) {
  // Surface a clearer error in dev
  // eslint-disable-next-line no-console
  console.error("Firebase API key is missing. Set EXPO_PUBLIC_API_KEY or extra.API_KEY in app.config.js");
}

export const firebaseConfig = {
	apiKey,
	authDomain: "syncmymeet-9b9b8.firebaseapp.com",
	databaseURL: "https://syncmymeet-9b9b8-default-rtdb.firebaseio.com",
	projectId: "syncmymeet-9b9b8",
	storageBucket: "syncmymeet-9b9b8.appspot.com",
	messagingSenderId: "988425588489",
	appId: "1:988425588489:web:cc6133a8cc386ab3184dd8",
	measurementId: "G-YCP814DF74",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// Prefer IndexedDB persistence; fall back to localStorage if needed
try {
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  setPersistence(auth, indexedDBLocalPersistence).catch(() => setPersistence(auth, browserLocalPersistence));
} catch (_) {}
export const db = getFirestore(app);
export const realtimeDatabase = getDatabase(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Connect to Functions emulator in development
// Check if running on localhost (dev server)
const isLocalhost = typeof window !== 'undefined' && 
                   (window.location.hostname === 'localhost' || 
                    window.location.hostname === '127.0.0.1' ||
                    window.location.hostname.includes('192.168'));

console.log('🔍 Firebase init check:', {
  hostname: typeof window !== 'undefined' ? window.location.hostname : 'N/A',
  NODE_ENV: process.env.NODE_ENV,
  ENV: Constants.expoConfig?.extra?.ENV,
  isLocalhost
});

// Temporarily disable emulator to use deployed functions
if (false && isLocalhost) {
  try {
    connectFunctionsEmulator(functions, 'localhost', 5002);
    console.log('🔧 Connected to Functions emulator on localhost:5002');
  } catch (error) {
    console.warn('⚠️ Could not connect to Functions emulator:', error);
  }
}

export default { auth, app, db, firebaseConfig, realtimeDatabase, storage, functions };


